<template>
	<v-layout row justify-center>
		<v-dialog
			v-model="value"
			fullscreen
			hide-overlay
			persistent
			transition="dialog-bottom-transition"
		>
			<v-card flat>
				<v-toolbar dark color="gradiente">
					<v-btn icon dark @click="close" class="custom_btn_close">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-toolbar
					scroll-target="#scrolling-home"
					style="z-index:1"
					extended
					extension-height="130"
					v-if="paymentData"
				>
					<v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly"
						>Detalle del pago</v-toolbar-title
					>
					<v-toolbar-title
						v-show="$vuetify.breakpoint.xsOnly"
						style="width:100%"
					>
						<v-flex class="titleSearch">
							<v-text-field
								class="mt-3"
								flat
								label="Buscar"
								prepend-inner-icon="search"
								solo-inverted
								clearable
								@click:append-outer="filterSearch"
								@click:clear="filterSearch"
								@keyup.enter="filterSearch"
								v-model="search"
							></v-text-field>
						</v-flex>
					</v-toolbar-title>
					<template v-slot:extension>
						<v-layout row wrap align-center align-content-center>
							<v-flex xs12 lg3>
								<v-list light style="background-color: transparent;">
									<div class="padding-side">
										<v-text-field
											:value="payment ? payment.name : ''"
											rows="1"
											row-height="24"
											auto-grow
											prepend-icon="title"
											disabled
										/>
									</div>
									<v-list-tile avatar>
										<v-list-tile-avatar>
											<v-icon class="red--text">account_circle</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>Creador</v-list-tile-title>
											<v-list-tile-sub-title v-if="payment && payment.user"
												>{{ payment.user.firstName }}
												{{ payment.user.lastName }}</v-list-tile-sub-title
											>
											<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-flex>
							<v-flex xs12 lg3>
								<v-list light style="background-color: transparent;">
									<v-list-tile avatar>
										<v-list-tile-avatar>
											<v-icon class="red--text">work</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>Concepto</v-list-tile-title>
											<v-list-tile-sub-title
												v-if="payment && payment.concept"
												>{{ payment.concept.name }}</v-list-tile-sub-title
											>
											<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-list-tile avatar>
										<v-list-tile-avatar>
											<v-icon class="red--text">monetization_on</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>Monto</v-list-tile-title>
											<v-list-tile-sub-title
												v-if="payment && payment.concept"
												>{{
													payment.concept.amount | formatCurrency
												}}</v-list-tile-sub-title
											>
											<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-flex>
							<v-flex xs12 lg3>
								<v-list light style="background-color: transparent;">
									<v-list-tile avatar>
										<v-list-tile-avatar>
											<v-icon class="red--text">event</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>Fecha de emisión</v-list-tile-title>
											<v-list-tile-sub-title v-if="payment">{{
												payment.createdAt | formatDate
											}}</v-list-tile-sub-title>
											<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-list-tile avatar>
										<v-list-tile-avatar>
											<v-icon class="red--text">event</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>Fecha de límite</v-list-tile-title>
											<v-list-tile-sub-title v-if="payment">{{
												payment.dueDate | formatDate
											}}</v-list-tile-sub-title>
											<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-flex>
							<v-flex xs12 lg3 class="titleSearch">
								<v-text-field
									flat
									label="Buscar"
									append-outer-icon="search"
									clearable
									solo-inverted
									hide-details
									@click:append-outer="filterSearch"
									@click:clear="filterSearch"
									@keyup.enter="filterSearch"
									v-model="search"
								></v-text-field>
							</v-flex>
						</v-layout>
					</template>
				</v-toolbar>
				<v-container
					elevation-2
					fluid
					id="scrolling-activity"
					style="max-height: 75vh;"
					class="table-full"
				>
					<v-layout row wrap>
						<v-flex xs12>
							<v-data-table
								:headers="headers"
								:rows-per-page-items="[25, 50, 100]"
								rows-per-page-text="Registros por página"
								:items="paymentStudents"
								:loading="working.wPayments"
								:pagination.sync="pagination"
								item-key="student.id"
								no-results-text="No se encontraron coincidencias"
								:no-data-text="
									permits['WATCH_PAYMENTS']
										? working.wPayments
											? 'Cargando'
											: paymentStudents.length > 0
											? ''
											: 'No hay pagos'
										: 'No tienes permiso de ver pagos'
								"
							>
								<template v-slot:headers>
									<tr>
										<th
											class="text-xs-left"
											style="width: 78px; max-width: 78px; min-width: 78px;"
										>
											Foto
										</th>
										<th
											class="text-xs-left"
											style="width: 380px; max-width: 380px; min-width: 380px;"
										>
											Nombre
										</th>
										<th
											class="text-xs-left"
											style="width: 240px; max-width: 240px; min-width: 240px;"
										>
											Nivel
										</th>
										<th
											class="text-xs-left"
											style="width: 160px; max-width: 160px; min-width: 160px;"
										>
											Grupo
										</th>
										<th
											class="text-xs-center"
											style="width: 96px; max-width: 96px; min-width: 96px;"
										>
											Género
										</th>
										<th
											class="text-xs-center"
											style="width: 96px; max-width: 96px; min-width: 96px;"
										>
											Cuenta
										</th>
										<th
											class="text-xs-left"
											style="width: 180px; max-width: 180px; min-width: 180px;"
										>
											Estatus
										</th>
									</tr>
								</template>
								<template v-slot:items="props">
									<td
										class="text-xs-left"
										style="width: 78px; max-width: 78px; min-width: 78px;"
									>
										<v-avatar
											:title="props.item.student.firstName"
											:size="avatarSize"
											color="grey lighten-4"
											v-if="
												props.item.student.imageStorage &&
													props.item.student.imageStorage.miniObjUrl
											"
										>
											<img
												:src="props.item.student.imageStorage.miniObjUrl"
												alt="avatar"
											/>
										</v-avatar>
										<v-icon :size="avatarSize" v-else>account_circle</v-icon>
									</td>
									<td
										class="text-xs-left"
										style="width: 380px; max-width: 380px; min-width: 380px;"
									>
										{{ props.item.student.firstName }}
										{{ props.item.student.lastName }}
									</td>
									<td
										class="text-xs-left"
										style="width: 240px; max-width: 240px; min-width: 240px;"
									>
										{{ props.item.student.level.typeLevel }}
									</td>
									<td
										class="text-xs-left"
										style="width: 160px; max-width: 160px; min-width: 160px;"
									>
										{{ props.item.student.gradeGroup.grade
										}}{{ props.item.student.gradeGroup.group }}
									</td>
									<td
										class="text-xs-center"
										style="width: 96px; max-width: 96px; min-width: 96px;"
									>
										<v-avatar>
											<v-icon
												:color="
													props.item.student.gender == 'MALE' ? 'blue' : 'pink'
												"
												>account_circle</v-icon
											>
										</v-avatar>
									</td>
									<td
										class="text-xs-center"
										style="width: 96px; max-width: 96px; min-width: 96px;"
									>
										<v-btn
											icon
											@click="toggleParents(props)"
											:disabled="
												!payment || !payment.metadata || !payment.metadata.split
											"
										>
											<v-badge color="green">
												<template v-slot:badge>
													<span>{{ props.item.payments || 0 }}</span>
												</template>
												<v-icon class="no-border">{{
													props.item.payments === 1 ? "person" : "group"
												}}</v-icon>
											</v-badge>
										</v-btn>
									</td>
									<td
										class="text-xs-left"
										style="width: 180px; max-width: 180px; min-width: 180px;"
									>
										<v-layout row>
											<v-flex shrink>
												<v-img :src="getIcon(props.item)" width="16px"></v-img>
											</v-flex>
											<v-flex grow>{{ props.item | paymentLegend }}</v-flex>
										</v-layout>
									</td>
								</template>
								<template v-slot:expand="props">
									<PaymentsParentsTable
										v-if="selected"
										:user="getUser"
										:idPayment="idPayment"
										:idStudent="props.item.student.id"
									/>
									<v-divider></v-divider>
								</template>
								<template v-slot:pageText="props"
									>{{ props.pageStart }} - {{ props.pageStop }} de
									{{ props.itemsLength }}</template
								>
							</v-data-table>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import PaymentsParentsTable from "../../Sections/Payments/PaymentsParentsTable";
export default {
	components: {
		PaymentsParentsTable,
	},
	props: ["value", "paymentData"],
	data: () => ({
		pagination: {
			sortBy: "name",
		},
		filters: {
			search: "",
		},
		working: {
			wPayments: false,
		},
		avatarSize: "30px",
		search: "",
		paymentStudents: [],
		idPayment: undefined,
		payment: undefined,
		headers: [
			{
				text: "Foto",
				align: "left",
				value: "imageStorage.miniObjUrl",
				filterItems: [],
			},
			{
				text: "Nombre del pago",
				align: "left",
				value: "firstName",
				filterItems: [],
			},
			{
				text: "Nivel",
				value: "level.grade",
				align: "left",
				filterItems: [],
			},
			{
				text: "Grupo",
				value: "gradeGroup.grade",
				filterItems: [],
				align: "right",
			},
			{
				text: "Género",
				value: "gender",
				filterItems: [],
				align: "left",
			},
			{
				text: "Cuenta",
				value: "payments",
				filterItems: [],
				align: "left",
			},
			{
				text: "Estatus",
				value: "paidPayments",
				filterItems: [],
				align: "center",
			},
		],
		selected: undefined,
		permits: [],
	}),
	filters: {
		paymentLegend: function(item) {
			if (item.payments === 1) {
				if (item.paidPayments === 1) {
					return "Pagado";
				}
				return "Pendiente";
			}

			if (item.payments === item.paidPayments) {
				return `Pagado ${item.paidPayments} de ${item.payments}`;
			}
			return `Pendiente ${item.payments - item.paidPayments} de ${
				item.payments
			}`;
		},
	},
	methods: {
		mapPermits() {
			var usr = this.getUser;
			if (!usr || !usr.webRole || !usr.webRole.catalogs) return;

			var catalogs = usr.webRole.catalogs;
			for (var c in catalogs) {
				if (catalogs[c].name.includes("PAYMENTS")) {
					this.permits[catalogs[c].name] = 1;
				}
			}
			this.working.wPayments = this.permits["WATCH_PAYMENTS"] ? true : false;
			if (this.working.wPayments) {
				this.getPaymentStudents();
			}
		},
		filterSearch(val) {
			this.filters.search = this.search || "";
			if (!this.working.wPayments) {
				this.getPaymentStudents(true);
			}
		},
		toggleParents(props) {
			if (
				this.selected &&
				this.selected.item.student.id === props.item.student.id
			) {
				props.expanded = false;
				delete this.selected;
			} else {
				props.expanded = true;
				this.selected = props;
			}
		},
		getPaymentStudents(forceUpdate) {
			this.working.wPayments = true;
			this.$store
				.dispatch("payments/getPaymentStudents", {
					id: this.paymentData.id,
					params: this.filters,
				})
				.then((response) => {
					this.working.wPayments = false;
					this.paymentStudents = response.data.items;
					this.payment = response.data.payment;
					if (forceUpdate) {
						this.$forceUpdate();
					}
				})
				.catch((error) => {
					this.working.wPayments = false;
				});
		},
		getIcon(item) {
			if (item.payments === item.paidPayments) {
				return require("@/assets/payments/payment_student_paid.png");
			}
			return require("@/assets/payments/payment_student_pending.png");
		},
		close() {
			this.$emit("input", !this.value);
		},
	},
	watch: {
		value() {
			if (this.value) {
				this.$forceUpdate();
			}
			if (this.value && this.paymentData != null) {
				this.getPaymentStudents(true);
			}
		},
	},
	mounted() {
		this.mapPermits();
	},
};
</script>

<style>
.padding-side {
	padding-left: 8%;
	padding-right: 4%;
}

.titleSearch .v-input .v-input__slot {
	border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
	display: flex !important;
	align-items: center !important;
	min-height: auto !important;
}
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
	max-height: calc(100vh - 486px);
	min-height: calc(100vh - 486px);
}

.custom_btn_close {
	position: absolute !important;
	right: 24px !important;
}
</style>
